import merge from 'lodash/merge';
import ReducerBuilder from 'classes/ReducerBuilder';
import {RetailerItemFormModes, StoreStockFormModes} from './utils';
import initialState from './initialState';
import {Types} from './actions';
import { Types as ImageTypes } from 'pages/Images/actions';

export default ReducerBuilder.make(initialState)

  /* RewardsDashboard */

  .forType(Types.SET_CURRENT_LANG)
  .reduce((state, action) => {
    state.selectedLang = action.lang;
  })
  .forType(Types.SET_CURRENT_YEAR)
  .reduce((state, action) => {
    state.selectedYear = action.year;
    state.fetchingEscrows = true;
  })
  .forType(Types.SET_CURRENT_MONTH)
  .reduce((state, action) => {
    state.selectedMonth = action.month;
  })

  .forType(Types.REQUEST_TOP_REWARDS)
  .reduce((state, action) => {
    // no-op
  })
  .forType(Types.RECEIVED_TOP_REWARDS)
  .reduce((state, action) => {
    // FIXME: might not need to filter once topRewards for es-LA and en-GB are non-empty
    state.topRewards = action.topRewards.filter(Boolean);
  })

  .forType(Types.RECEIVED_STORE_ACCOUNT)
  .reduce((state, action) => {
    state.storeAccountsById[action.storeAccount.id] = action.storeAccount;
  })
  .forType(Types.SET_STORE_ACCOUNT)
  .reduce((state, action) => {
    state.currentStoreAccountId = action.storeAccount.id;
  })

  .forType(Types.REQUEST_NGC_ENDPOINT_LIST)
  .reduce((state, action) => {
    //
  })
  .forType(Types.RECEIVED_NGC_ENDPOINT_LIST)
  .reduce((state, action) => {

    state.ngcEndpointList = action.ngcEndpointList;
    
  })
  .forType(Types.RECEIVED_NGC_ENDPOINT_FOR_STORE)
  .reduce((state, action) => {
    state.ngcEndpointForStore = action.ngcEndpoint;
  })

  .forType(Types.SET_NGC_ENDPOINT)
  .reduce((state, action) => {
    state.ngcEndpoint = action.ngcEndpoint;
  })

  .forType(Types.RECEIVED_RETAILERS)
  .reduce((state, action) => {
    console.log("RECEIVED_RETAILERS")
    state.retailers = action.retailers;
  })
  .forType(Types.RECEIVED_STORE_ESCROW)
  .reduce((state, action) => {
    state.storeEscrowsById[action.storeEscrow.id] = action.storeEscrow;
  })
  .forType(Types.RECEIVED_STORE_ESCROWS)
  .reduce((state, action) => {
    for (const escrow of action.storeEscrows) {
      state.storeEscrowsById[escrow.id] = escrow;
    }

    state.fetchingEscrows = false;
  })

  /* CreateStoreEscrowModal */

  .forType(Types.START_CREATE_STORE_ESCROW)
  .reduce((state, action) => {
    state.creatingStoreEscrow = true;
  })
  .forType(Types.SUBMIT_CREATE_STORE_ESCROW)
  .reduce((state, action) => {
    state.createStoreEscrowError = null;
    state.createStoreEscrowSubmitted = true;
  })
  .forType(Types.ERROR_CREATING_STORE_ESCROW)
  .reduce((state, action) => {
    state.createStoreEscrowError = action.errorCode;
  })
  .forType(Types.CREATED_STORE_ESCROW)
  .reduce((state, action) => {
    state.createdStoreEscrow = true;
  })
  .forType(Types.END_CREATE_STORE_ESCROW)
  .reduce((state, action) => {
    state.createdStoreEscrow = false;
    state.creatingStoreEscrow = false;
    state.createStoreEscrowSubmitted = false;
    state.createStoreEscrowError = null;
  })

  /* RewardsTable */

  .forType(Types.REQUEST_STORE_CATALOG)
  .reduce((state, action) => {
    state.fetchingStoreCatalog = true;
  })
  .forType(Types.RECEIVED_STORE_CATALOG)
  .reduce((state, action) => {
    state.fetchingStoreCatalog = false;
  })
  .forType(Types.EXPORT_STORE_DATA)
  .reduce((state, action) => {
    state.exportingStoreData = true;
    state.exportedStoreData = false;
    state.exportStoreDataSuccess = false;
  })
  .forType(Types.EXPORTED_STORE_DATA)
  .reduce((state, action) => {
    state.exportingStoreData = false;
    state.exportedStoreData = true;
    state.exportStoreDataSuccess = action.success;
  })
  .forType(Types.CLOSE_EXPORT_STATUS_MODAL)
  .reduce((state, action) => {
    state.exportedStoreData = false;
  })

  /* RetailerItemModal */

  .forType(Types.REQUEST_RETAILER_ITEM_IMAGES)
  .reduce((state, action) => {
    // no-op
    
  })
  .forType(Types.START_WRITE_RETAILER_ITEM)
  .reduce((state, action) => {
    // clear any lingering API errors from the previous invocation of the modal.
    state.createRetailerItemError = null;

    state.writingRetailerItem = true;
    state.retailerItemFormMode = action.mode;

    if (action.mode === RetailerItemFormModes.Update) {
      state.writingRetailerItemResource = action.retailerItemResource;
    } else {
      state.writingRetailerItemResource = {
        lang: state.selectedLang
      };
    }
  })
  .forType(ImageTypes.CREATED_IMAGE)
  .reduce((state, action) => {
    console.log("CREATED_IMAGE");
  })

  .forType(Types.UPDATE_RETAILER_ITEM_IN_PROGRESS)
  .reduce((state, action) => {
    state.createRetailerItemError = null;
    state.writingRetailerItemResource = merge({}, state.writingRetailerItemResource, action.change);
    console.log("HERE");
    
  })
  .forType(Types.SUBMIT_CREATE_RETAILER_ITEM)
  .reduce((state, action) => {
    state.createRetailerItemError = null;
    state.writeRetailerItemSubmitted = true;
  })
  .forType(Types.ERROR_CREATING_RETAILER_ITEM)
  .reduce((state, action) => {
    state.writeRetailerItemSubmitted = false;
    state.createRetailerItemError = action.errorCode;
  })
  .forType(Types.END_WRITE_RETAILER_ITEM)
  .reduce((state, action) => {
    state.writingRetailerItem = false;
    state.writeRetailerItemSubmitted = false;
    state.createRetailerItemError = null;
    state.writingRetailerItemResource = {};
    state.retailerItemFormMode = null;
  })

  /* PurchaseInfoModal */

  .forType(Types.START_VIEW_PURCHASE_INFO)
  .reduce((state, action) => {
    state.viewingPurchaseInfo = true;
    state.viewingPurchaseInfoFor = action.reward;
  })
  .forType(Types.REQUEST_STORE_ORDERS)
  .reduce((state, action) => {
    state.fetchingStoreOrders = true;
  })
  .forType(Types.RECEIVED_STORE_ORDERS)
  .reduce((state, action) => {
    state.fetchingStoreOrders = false;
    console.log(action); 
    state.storeOrders = action.storeOrders;
  })
  .forType(Types.SUBMIT_RESEND_ORDER_EMAIL)
  .reduce((state, action) => {
    state.resentOrderEmailFor = null;
    state.resendOrderEmailSubmittedFor = action.orderId;
  })
  .forType(Types.RESENT_ORDER_EMAIL)
  .reduce((state, action) => {
    state.resentOrderEmailFor = state.resendOrderEmailSubmittedFor;
    state.resendOrderEmailSubmittedFor = false;
  })
  .forType(Types.CLEAR_RESEND_NOTIFICATION)
  .reduce((state, action) => {
    state.resentOrderEmailFor = null;
  })
  .forType(Types.END_VIEW_PURCHASE_INFO)
  .reduce((state, action) => {
    state.viewingPurchaseInfo = false;
    state.viewingPurchaseInfoFor = null;
    state.resendOrderEmailSubmittedFor = null;
    state.resentOrderEmailFor = null;
  })

  /* StoreStockModal */

  .forType(Types.START_INCREASE_ITEM_STOCK)
  .reduce((state, action) => {
    state.storeStockFormMode = StoreStockFormModes.Increase;
    state.updatingStoreStockFor = action.retailerItem;
  })
  .forType(Types.SUBMIT_INCREASE_ITEM_STOCK)
  .reduce((state, action) => {
    state.updatingStoreStock = true;
  })

  .forType(Types.START_DECREASE_ITEM_STOCK)
  .reduce((state, action) => {
    state.storeStockFormMode = StoreStockFormModes.Decrease;
    state.updatingStoreStockFor = action.retailerItem;
  })
  .forType(Types.SUBMIT_DECREASE_ITEM_STOCK)
  .reduce((state, action) => {
    state.updatingStoreStock = true;
  })

  .forType(Types.END_UPDATE_ITEM_STOCK)
  .reduce((state, action) => {
    state.storeStockFormMode = null;
    state.updatingStoreStockFor = null;
    state.updatingStoreStock = false;
  })

  /* AutoSaveQuantityInput */

  .forType(Types.SUBMIT_UPDATE_QUANTITY)
  .reduce((state, action) => {
    state.quantityUpdateSubmittedFor[action.retailerItemId] = true;
    delete state.quantityUpdateErrors[action.retailerItemId];
    delete state.quantityUpdateSuccesses[action.retailerItemId];
  })
  .forType(Types.QUANTITY_UPDATE_ERROR)
  .reduce((state, action) => {
    state.quantityUpdateErrors[action.retailerItemId] = action.errorCode;
    delete state.quantityUpdateSuccesses[action.retailerItemId];
    delete state.quantityUpdateSubmittedFor[action.retailerItemId];
  })
  .forType(Types.QUANTITY_UPDATE_SUCCESS)
  .reduce((state, action) => {
    state.quantityUpdateSuccesses[action.retailerItemId] = true;
    delete state.quantityUpdateErrors[action.retailerItemId];
    delete state.quantityUpdateSubmittedFor[action.retailerItemId];
  })
  .build();



// WEBPACK FOOTER //
// ./public/pages/Rewards/reducer.js